<script async setup>

const props = defineProps({
    icons: {
        type: [Array, Boolean],
        default: () => [],
    },
    paymentIcons: {
        type: [Array, Boolean],
        default: () => [],
    },
    items: {
        type: Array,
        default: () => [],
    },
    contacts: { 
        type: Array,
        default: () => [] 
    },
    socialText: {
        type: String,
        default: "",
    },
    paymentText: {
        type: String,
        default: "",
    },
});
</script>

<template>
    <footer class="bg-ts-white text-ts-black py-7 relative overflow-hidden">
        <div class="max-w-ts-content mx-auto px-4 relative z-10">
            <div class="mb-4 -ml-1">
                <kd-icon-logo width="210" height="80" fill="black" />
            </div>
            <div v-if="props.items && props.items.length" class="grid grid-cols-2 phone:grid-cols-3 midbook:grid-cols-5 gap-6">
                <!-- Kontakte -->
                <section class="col-span-2 phone:col-span-1 midbook:col-span-1">
                    <div v-if="props.contacts && props.contacts.length" class="space-y-6">
                        <div v-for="(contact, index) in props.contacts" :key="index">
                            <div class="text-sm phone:text-base mb-0 phone:mb-2">{{ contact.title }}</div>
                            <div v-if="contact.phone">
                                <a :href="`tel:${contact.phone.replace(/[^+\d]/g, '')}`" class="text-xs phone:text-sm no-underline hover:underline"> 
                                    {{ contact.phone }}
                                </a>
                            </div>
                            <div v-if="contact.hours">
                                <div v-for="(line, lineIndex) in contact.hours.split('\n')" :key="lineIndex" class="text-xs phone:text-sm">
                                    {{ line }}
                                </div>
                            </div>
                            <div v-if="contact.email">
                                <a :href="`mailto:${contact.email}`" class="text-xs phone:text-sm no-underline hover:underline">
                                    {{ contact.email }}
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
                <!-- Labels -->
                <nav v-for="(item, index) in props.items" :key="index">
                    <component
                        :is="item.url === '#' ? 'div' : 'a'"
                        :href="item.url === '#' ? undefined : item.url"
                        class="block font-bold text-sm phone:text-base mb-2"
                        :title="item.url === '#' ? '' : (item.title ? item.title : item.label)"
                    >
                        {{ item.label }}
                    </component>
                
                    <ul v-if="item.children && item.children.length">
                        <li
                            v-for="(child, childIndex) in item.children"
                            :key="childIndex"
                            :class="{'mb-2': childIndex < item.children.length - 1}"
                        >
                            <a
                                :title="child.title ? child.title : child.label"
                                :href="child.url"
                                class="text-xs phone:text-sm hover:font-bold"
                            >
                                {{ child.label }}
                            </a>
                        </li>
                    </ul>
                </nav>
                <!-- Icons -->
                <div class="flex flex-col gap-6">
                    <div class="gap-2">
                        <div v-if="props.paymentText" class="pb-4 text-sm phone:text-base font-bold">
                            {{ props.paymentText }}
                        </div>
                        <div v-if="props.paymentIcons && props.paymentIcons.length" class="flex items-center gap-5">
                            <component
                                v-for="(icon, index) in props.paymentIcons"
                                :key="index"
                                :is="!icon.url ? 'div' : 'a'"
                                :href="!icon.url ? '' : 'a'"
                                :title="!icon.url ? '' : (icon.label)"
                            >
                                <component
                                    :is="`kd-icon-${icon.icon}`"
                                    height="30"
                                    width="100%"
                                    fill="black"
                                />
                            </component>
                        </div>
                    </div>
                    <div class="gap-2">
                        <div v-if="props.socialText" class="pb-4 text-sm phone:text-base font-bold">
                            {{ props.socialText }}
                        </div>
                        <div v-if="props.icons && props.icons.length" class="flex items-center gap-6">
                            <a
                                v-for="icon in props.icons"
                                :key="icon.label"
                                :href="icon.link"
                                :title="icon.label"
                                target="_blank"
                            >
                                <component
                                    :is="`kd-icon-${icon.icon}`"
                                    height="40"
                                    width="100%"
                                    fill="black"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>
